import React from 'react';
import { Typography } from '@mui/material';
import { Dropdown, useI18nContext } from '@procore/core-react';
import { SortBy } from '../../data/filters/filters';
import { sendAnalyticsEvent } from '../Analytics/utilities';

const SearchSortBySelector = ({ onChange, value }) => {
  const I18n = useI18nContext();
  return (
    <Dropdown
      data-test-id="sort-by-selector"
      // @ts-ignore
      label={
        <Typography component="h2" variant="h3">
          {I18n.t('components.sort_by_selector.label', {
            selected: value,
          })}
        </Typography>
      }
      onSelect={({ item }) => {
        sendAnalyticsEvent('Changed Sorting', item.key, 'Changed Sorting');
        onChange(item);
      }}
      style={{ float: 'right' }}
    >
      {SortBy.map((item) => (
        <Dropdown.Item key={`sort-by-${item.key}`} item={item}>
          {item.label}
        </Dropdown.Item>
      ))}
    </Dropdown>
  );
};

export default SearchSortBySelector;
